import * as React from 'react';
import { FunctionComponent } from 'react';
import classNames from 'classnames';
import './Switch.scss';

interface Props {
  value?: boolean;
  checked?: boolean;
  onChange: (event: any) => void;
  text?: string;
  label?: string;
  customClass?: string;
  name: string;
  disabled?: boolean;
}

export const Switch: FunctionComponent<Props> = props => {
  const { customClass, onChange, text, label, value, checked, name, disabled } = props;
  const isChecked = typeof checked !== 'undefined' ? checked : Boolean(value);
  const switchClass = classNames('sit-switch', customClass);
  const switchLabel = typeof label !== 'undefined' ? label : text;

  return (
    <label className={switchClass} data-disabled={disabled}>
      <input
        name={name}
        onChange={onChange}
        checked={isChecked}
        type="checkbox"
        role="switch"
        disabled={disabled}
      />
      <span className="sit-switch__track"><span className="sit-switch__thumb" /></span>
      {switchLabel ? <span className="sit-switch__label">{switchLabel}</span> : null}
    </label>
  );
};

Switch.displayName = 'Switch';